import Link from '@/lib/link'
import { ContentPage, Prose, Section } from '@/components/content-page'

export default function AboutPage() {
  return (
    <ContentPage
      eyebrow="// about"
      title="About NewChirp"
      description="A modern reimagining of a tool the amateur radio community has relied on for years."
    >
      <Prose>
        <Section title="Built on a classic">
          <p>
            For more than a decade, CHIRP has been the go-to free tool for programming amateur
            radios. It earned its reputation by doing one thing exceptionally well and supporting an
            enormous range of hardware. NewChirp stands on that foundation.
          </p>
          <p>
            NewChirp is a new product that carries the classic CHIRP workflow forward with a
            modernized experience, while keeping everything that made the original great: free,
            open source, cross-platform, and community-driven.
          </p>
        </Section>

        <Section title="Who makes it">
          <p>
            NewChirp is led by <span className="text-foreground">Rick Lopez</span>, with help from a
            community of operators, testers, and contributors. It is released free of charge under
            the GPL.
          </p>
          <a
            href="mailto:rick@newchirp.net"
            className="inline-flex w-fit items-center gap-2 rounded-lg bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-opacity hover:opacity-90"
          >
            Email rick@newchirp.net
          </a>
        </Section>

        <Section title="Get involved">
          <p>
            Whether you want to program your first radio or help build the software itself, there is
            a place for you. Start with the{' '}
            <Link href="/beginners-guide" className="text-primary underline underline-offset-4">
              Beginners Guide
            </Link>{' '}
            or join the{' '}
            <Link href="/community" className="text-primary underline underline-offset-4">
              community
            </Link>
            .
          </p>
        </Section>
      </Prose>
    </ContentPage>
  )
}
